import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format date as "12 Feb 2025"
 */
export function formatShortDate(date: Date | string): string {
  return format(new Date(date), "d MMM yyyy");
}

/**
 * Format date as "12 February 2025"
 */
export function formatLongDate(date: Date | string): string {
  return format(new Date(date), "d MMMM yyyy");
}

/**
 * Format date as "Monday, 12 February 2025"
 */
export function formatFullDate(date: Date | string): string {
  return format(new Date(date), "EEEE, d MMMM yyyy");
}

/**
 * Format date with time as "12 Feb 2025 at 3:45 pm"
 */
export function formatDateTime(date: Date | string): string {
  return format(new Date(date), "d MMM yyyy 'at' h:mm a");
}

/**
 * Format time only as "3:45 pm"
 */
export function formatTime(date: Date | string): string {
  return format(new Date(date), "h:mm a");
}

/**
 * Format short date without year as "12 Feb"
 */
export function formatShortDateNoYear(date: Date | string): string {
  return format(new Date(date), "d MMM");
}

export function isEmptyHtml(html: string): boolean {
  if (!html) return true;
  // Remove HTML tags and whitespace to check if there's actual content
  const text = html.replace(/<[^>]*>/g, '').trim();
  return text.length === 0;
}
